export type ExcelValueConflict = {
  key: string;
  label: string;
  options: { source: string; value: unknown }[];
};

export const mergeExcelValues = (
  sources: { source: string; values: Record<string, unknown> }[],
  label: (key: string) => string,
) => {
  const values: Record<string, unknown> = {};
  const candidates = new Map<string, ExcelValueConflict['options']>();
  for (const source of sources) {
    for (const [key, value] of Object.entries(source.values)) {
      if (!(key in values)) values[key] = value;
      if (value === undefined || value === null || (typeof value === 'string' && !value.trim()))
        continue;
      const options = candidates.get(key) || [];
      if (!options.some((option) => JSON.stringify(option.value) === JSON.stringify(value))) {
        options.push({ source: source.source, value });
      }
      candidates.set(key, options);
      values[key] = options[0].value;
    }
  }
  return {
    values,
    conflicts: [...candidates]
      .filter(([, options]) => options.length > 1)
      .map(([key, options]) => ({ key, label: label(key), options })),
  };
};

export const displayExcelValue = (value: unknown): string =>
  value && typeof value === 'object' ? Object.values(value).join(' / ') : String(value ?? '');
